import { tns } from 'tiny-slider/src/tiny-slider';

class MediaContentSlider {
	constructor(el) {
		this.el = el;

		const mediaContentSlider = tns({
			container: this.el,
			autoplay: false,
			autoplayButtonOutput: false,
			mouseDrag: true,
			preventScrollOnTouch: 'auto',
			swipeAngle: false,
			speed: 800,
			controls: true,
			nav: true,              
			navPosition: 'bottom' ,
			mode: 'gallery',
			autoHeight: true 
		});

		return mediaContentSlider;
		
	}
}

export default MediaContentSlider;